var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.723 1.34a.31.31 0 0 1 .554 0l1.348 2.73a1.24 1.24 0 0 0 .93.676l3.014.441a.31.31 0 0 1 .171.527l-2.179 2.123a1.24 1.24 0 0 0-.356 1.095l.514 2.998a.31.31 0 0 1-.45.327l-2.693-1.416a1.24 1.24 0 0 0-1.151 0L3.73 12.257a.31.31 0 0 1-.449-.327l.514-2.997a1.24 1.24 0 0 0-.356-1.096L1.26 5.715a.31.31 0 0 1 .172-.529l3.013-.44a1.24 1.24 0 0 0 .931-.677z"
  })));
};
export default SvgStar;